<template>
    <el-container>
        <el-main>
            <el-dialog :title="permissionTitle" :visible.sync="showPermission" width="35%" :close-on-click-modal=false :before-close="handleDialogClose">
                <el-form ref="formData" :model="formData" :rules="rules" label-width="100px"  class="demo-ruleForm">
                    <el-form-item label="父级名称：" prop="parentName">
                        <el-input v-model="formData.parentName" :disabled="true"  placeholder="父级名称"></el-input>
                    </el-form-item>
                    <el-form-item label="菜单名称：" prop="menuName">
                        <el-input v-model="formData.menuName"  placeholder="菜单名称"></el-input>
                    </el-form-item>
                    <el-form-item  label="类型：" prop="type">
                        <el-select v-model="formData.type" placeholder="请选择" :disabled="showType" >
                            <el-option label="菜单" :value="1"></el-option>
                            <el-option label="按钮" :value="2"></el-option>
                        </el-select>
                    </el-form-item>
                    <!--<el-form-item  label="系统级别：" prop="status">-->
                        <!--<el-switch-->
                                <!--v-model="formData.isSystem"-->
                                <!--active-color="#13ce66"-->
                                <!--inactive-color="#ff4949">-->
                        <!--</el-switch>-->
                    <!--</el-form-item>-->
                    <!--<el-form-item  label="是否可见：" prop="status">-->
                        <!--<el-switch-->
                                <!--v-model="formData.isDisplay"-->
                                <!--active-color="#13ce66"-->
                                <!--inactive-color="#ff4949">-->
                        <!--</el-switch>-->
                    <!--</el-form-item>-->
                    <el-form-item label="图标：" prop="icon">
                        <el-input v-model="formData.icon"  placeholder="图标"></el-input>
                    </el-form-item>
                    <el-form-item label="路径：" prop="url">
                        <el-input v-model="formData.url"  placeholder="路径"></el-input>
                    </el-form-item>
                    <el-form-item label="权限标识：" prop="perms">
                        <el-input v-model="formData.perms"  placeholder="权限标识"></el-input>
                    </el-form-item>
                    <el-form-item  label="状态：" prop="status">
                        <el-radio v-model="formData.status" :label= "1" >启用</el-radio>
                        <el-radio v-model="formData.status" :label= "2" >禁用</el-radio>
                    </el-form-item>
                    <el-form-item  label="排序：" prop="sort">
                        <el-input v-model="formData.sort"  placeholder="排序"></el-input>
                    </el-form-item>

                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="handleDialogClose">取 消</el-button>
                    <el-button type="primary" @click="savePermission('formData')">确 定</el-button>
                </div>
            </el-dialog>
            <el-button type="success" icon="el-icon-circle-plus-outline" size="small" round @click="addPermission" class="but-cls">添加</el-button>
            <el-table
                    :data="tableData"
                    style="width: 100%;margin-bottom: 20px;"
                    row-key="permissionId"
                    border
                    ref="tableData"
                    :loading = "loading"
                    default-expand-all
                    :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
                <el-table-column
                        prop="menuName"
                        label="菜单名称"
                        >
                </el-table-column>
                <el-table-column
                        prop="url"
                        label="路径"
                >
                </el-table-column>
                <el-table-column
                        prop="perms"
                        label="权限标识"
                >
                </el-table-column>
                <el-table-column
                        prop="type"
                        label="类型"
                        width="180"
                        :formatter="typeFormat"
                >
                </el-table-column>
                <el-table-column
                        prop="status"
                        label="状态"
                        width="180"
                        :formatter="statusFormat"
                >
                </el-table-column>
                <el-table-column
                        fixed="right"
                        label="操作"
                        width="200"
                >
                    <template slot-scope="scope">
                        <template v-if="scope.row.classLayer < 4">
                            <el-button @click="addPermission(scope.$index, scope.row)"  size="small" type="text">添加</el-button>
                        </template>
                        <el-button @click="updatePermission(scope.$index, scope.row)" type="text"  size="small">修改</el-button>
                        <el-button @click="deletePermission(scope.$index, scope.row)" type="text"  size="small">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-main>
    </el-container>
</template>

<script>
    import https from '@/https.js'
    import validate from '@/api/validate.js'

    const formData = {
        permissionId: "",
        menuName: "",
        parentId: "",
        parentName: "",
        type: 1,
        status: 1,
        isSystem: true,
        isDisplay: true,
        perms: "",
        url: "",
        icon: "",
        sort: "",
        classLayer: "",
    };
    export default {
        name: "",
        data() {
            return {
                showType: true,
                showTree: true,
                tableData: [],
                formData: JSON.parse(JSON.stringify(formData)),
                top: false,
                showPermission: false,
                loading: false,
                permissionTitle: "",
                defaultProps: {
                    children: 'children',
                    label: 'menuName'
                },
                rules: {
                    menuName:[
                        { required: true, message: '请填写菜单名称', trigger: 'blur' },
                        {  max: 50, message: '长度不得超过 50 个字符', trigger: 'blur' }
                    ],
                    icon: [
                        {  max: 100, message: '长度不得超过 100 个字符', trigger: 'blur' }
                    ],
                    url: [
                        {  max: 200, message: '长度不得超过 200 个字符', trigger: 'blur' }
                    ],
                    perms: [
                        {  max: 100, message: '长度不得超过 100 个字符', trigger: 'blur' }
                    ],
                    sort: [
                        { validator: validate.validateSort, trigger: 'blur' }
                    ]
                }
            }
        },
        methods: {
            handleDialogClose() {
                this.showPermission = false;
                this.formData.permissionId = "";
                this.permissionTitle = "添加权限"
                this.formData = JSON.parse(JSON.stringify(formData));
                this.$refs.formData.clearValidate();
            },
            statusFormat(row, column, cellValue, index) {
                if(cellValue == 1) {
                    return "启用";
                }
                if(cellValue == 2) {
                    return "禁用";
                }
                return "其他";
            },
            typeFormat(row, column, cellValue, index) {
                if(cellValue == 1) {
                    return "菜单";
                }
                if(cellValue == 2) {
                    return "按钮";
                }
                return "其他";
            },
            addPermission(index, row) {
                this.showPermission = true;
                let parentName = "";
                let classLayer = "1";
                let parentId = "";
                if(row) {
                    console.log(row);
                    let _row = JSON.parse(JSON.stringify(row));
                    parentId = _row.permissionId;
                    parentName = _row.menuName;
                    classLayer = _row.classLayer+1;
                }
                this.formData.parentId = parentId;
                this.formData.parentName = parentName;
                this.formData.classLayer = classLayer;
              this.showType = true;
              if(classLayer > 3) {
                this.showType = false;
              } else {
                this.formData.type = 1;
              }
            },

            updatePermission(index, row) {
                this.permissionTitle = "修改权限"
                this.formData = JSON.parse(JSON.stringify(row));
                this.showPermission = true;
            },
            savePermission(formName) {
                this.$refs[formName].validate((valid) => {
                    if (!valid) {
                        this.$message.error('请正确填写信息！');
                        return false;
                    }else {
                        let params = this.formData;
                        let url = "/managerPermission/addPermission";
                        console.log(this.formData.permissionId);
                        if(this.formData.permissionId != "") {
                            url = "/managerPermission/updatePermission";
                        }
                        https.fetchPost(url,params ,"json").then((data) => {
                            let code = data.data.code;
                            let msg = data.data.msg;
                            if(code == '200') {
                                this.$message({
                                    message: '操作成功',
                                    type: 'success'
                                });
                                this.showPermission = false;
                                this.formData = JSON.parse(JSON.stringify(formData));
                                this.search();
                            } else {
                                this.$message.error('操作失败:'+msg);
                            }

                        }).catch(err=>{
                                console.log(err);
                                this.$message.error('网络错误');
                            }
                        )
                    }
                });
            },
            search() {
                let params = {
                };
                https.fetchGet('/managerPermission/selectPermissionTree',JSON.parse(JSON.stringify(params)),"form" ).then((data) => {
                    let code = data.data.code;
                    if(code == '200') {
                        this.tableData = data.data.data;
                        this.loading = false;
                    }
                }).catch(err=>{
                        console.log(err)
                    }
                )
            },
            deletePermission(index, row) {
                this.$confirm('此操作将删除权限信息, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(()=>{
                    let params = {
                      permissionIdList: [row.permissionId]
                    };
                    
                    https.fetchPost('/managerPermission/deleteByPermissionIdList',params , "json").then((data) => {
                        let code = data.data.code;
                        let msg = data.data.msg;
                        if(code == '200') {
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                            this.search();
                        } else {
                            this.$message({
                                type: 'info',
                                message: '删除失败:'+msg
                            });
                        }
                    }).catch(err=>{
                            this.$message.error('网络错误');
                        }
                    )
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            }
        },
      created: function () {
          this.search()
      }
    }
</script>

<style scoped>
    .but-cls {
        margin-bottom: 10px;
    }
</style>